// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606180903/js/" + chunkId + "." + {"44":"447908c5","225":"a768f902","481":"cae36709","486":"1ca9fe24","770":"e5cde6f9"}[chunkId] + ".0.011864266213847174.chunk.js";
};